import escapeStringRegexp from "escape-string-regexp";

export const checkIsQueryMatch = (query: string, targetTitle: string) => new RegExp(escapeStringRegexp(query)).test(targetTitle);
